import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'

export async function listAllPermssions(app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/features`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function listRolePermissionsV2(id: string, app: any, apiHost: string) {
  const URL = `${getChatApiBase(
    app,
    apiHost,
  )}/roles/${id}/permissions?includePermissionObject=true`

  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}

export async function getRolePermissionsV2Values(id: string, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}/permissions`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}

export async function updateRolePermissionsV2(id: string, post: any, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}/permissions`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}

export async function resetRolePermissionsV2(id: string, permissionId: string, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}/permissions/${permissionId}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}
